import _ from 'lodash';
import React from 'react';

import {default as Modal, withModal} from 'components/Modal';
import {
  ArrivalRoomCheckBasicInformation,
  ArrivalRoomCheckDetails
} from './components';
import {
  RoomCheckDetailImagesSection,
  RoomCheckDetailDocumentSection
} from 'containers/BookingSetDetail/components';

import {
  MODALS,
  fetchArrivalRoomCheck,
  removeArrivalRoomCheckImage,
  verifyArrivalRoomCheckImageUpload,
  REFETCH_ROOM_CHECK_DELAY,
  fetchArrivalRoomChecks,
  fetchBookingSet,
  fetchRoomChecksTimeline,
  verifyArrivalRoomCheckInventoryUpload,
  removeArrivalRoomCheckInventory,
  editArrivalRoomCheckExistingDamages,
  editArrivalRoomCheckDescription
} from 'ducks/bookingSets';
import {uploadFile} from 'ducks/files';

import {storeDataInModal} from 'ducks/modals';

import {composeActions, delayedAction} from 'ducks/common';

import {
  signRoomCheckImage as signRoomCheckImageSdk,
  signInventoryDocument as signInventoryDocumentSdk
} from 'sdk/bookingSets';

import inventoryIcon from 'assets/icons/inventory-icon.svg';

import './styles.css';

class ArrivalRoomCheckDetailModal extends React.Component<any> {
  componentDidMount() {
    const {bookingSetId, roomCheckId} = this.props.data;

    this.props.fetchArrivalRoomCheck(
      {bookingSetId, roomCheckId},
      this.fetchArrivalRoomCheckExtraActions()
    );
  }

  fetchArrivalRoomCheckExtraActions = () =>
    this.props.storeDataExtraActions(data => ({
      arrivalRoomCheck: data
    }));

  removeImage = ({imageId}) => {
    const {bookingSetId, roomCheckId} = this.props.data;

    const extraActions = [
      () =>
        fetchArrivalRoomCheck(
          {roomCheckId, bookingSetId},
          this.fetchArrivalRoomCheckExtraActions()
        ),
      () => fetchArrivalRoomChecks({bookingSetId}),
      () => fetchBookingSet({bookingSetId})
    ];

    this.props.removeArrivalRoomCheckImage(
      {
        bookingSetId,
        arrivalRoomCheckId: roomCheckId,
        roomCheckImageId: imageId
      },
      extraActions
    );
  };

  dropImage = ({image}) => {
    const {bookingSetId, roomCheckId} = this.props.data;

    const startUploadingAction = () =>
      storeDataInModal({
        modalName: MODALS.ARRIVAL_ROOM_CHECK_DETAIL_MODAL,
        data: {
          uploadingImage: true
        }
      });

    const finishUploadingAction = () =>
      composeActions([
        () =>
          delayedAction({
            delay: REFETCH_ROOM_CHECK_DELAY,
            action: () =>
              fetchArrivalRoomCheck(
                {roomCheckId, bookingSetId},
                this.fetchArrivalRoomCheckExtraActions()
              )
          }),
        ...this.props.storeDataExtraActions(() => ({
          uploadingImage: false
        })),
        () =>
          delayedAction({
            delay: REFETCH_ROOM_CHECK_DELAY,
            action: () => fetchArrivalRoomChecks({bookingSetId})
          }),
        () => fetchBookingSet({bookingSetId})
      ]);

    const storeIdentifierAction = identifier => {
      const successExtraActions = [
        () =>
          storeDataInModal({
            modalName: MODALS.ARRIVAL_ROOM_CHECK_DETAIL_MODAL,
            data: {
              imageUploadError: null
            }
          })
      ];
      const failureExtraActions = [
        ({errors}) =>
          storeDataInModal({
            modalName: MODALS.ARRIVAL_ROOM_CHECK_DETAIL_MODAL,
            data: {
              imageUploadError: _.get(errors, '_error')
            }
          })
      ];
      return verifyArrivalRoomCheckImageUpload(
        {
          imageIdentifier: identifier,
          bookingSetId,
          arrivalRoomCheckId: roomCheckId
        },
        successExtraActions,
        failureExtraActions
      );
    };

    const signData = {
      filename: image.name,
      fileType: image.type,
      bookingSetId
    };

    this.props.uploadFile({
      file: image,
      signSdk: signRoomCheckImageSdk,
      signData,
      startUploadingAction,
      storeIdentifierAction,
      finishUploadingAction
    });
  };

  removeInventory = ({documentId}) => {
    const {bookingSetId, roomCheckId} = this.props.data;

    const extraActions = [
      () =>
        fetchArrivalRoomCheck(
          {roomCheckId, bookingSetId},
          this.fetchArrivalRoomCheckExtraActions()
        ),
      () => fetchArrivalRoomChecks({bookingSetId}),
      () => fetchBookingSet({bookingSetId}),
      () => fetchRoomChecksTimeline({bookingSetId})
    ];

    this.props.removeArrivalRoomCheckInventory(
      {
        bookingSetId,
        arrivalRoomCheckId: roomCheckId,
        roomCheckInventoryId: documentId
      },
      extraActions
    );
  };

  dropInventory = ({document}) => {
    const {bookingSetId, roomCheckId} = this.props.data;

    const startUploadingAction = () =>
      storeDataInModal({
        modalName: MODALS.ARRIVAL_ROOM_CHECK_DETAIL_MODAL,
        data: {
          uploadingInventory: true
        }
      });

    const finishUploadingAction = () =>
      composeActions([
        () =>
          delayedAction({
            delay: REFETCH_ROOM_CHECK_DELAY,
            action: () =>
              composeActions([
                () =>
                  fetchArrivalRoomCheck(
                    {roomCheckId, bookingSetId},
                    this.fetchArrivalRoomCheckExtraActions()
                  ),
                () => fetchArrivalRoomChecks({bookingSetId}),
                () => fetchBookingSet({bookingSetId}),
                () => fetchRoomChecksTimeline({bookingSetId})
              ])
          }),
        ...this.props.storeDataExtraActions(() => ({
          uploadingInventory: false
        }))
      ]);

    const storeIdentifierAction = identifier =>
      verifyArrivalRoomCheckInventoryUpload({
        documentIdentifier: identifier,
        bookingSetId,
        arrivalRoomCheckId: roomCheckId
      });

    const signData = {
      filename: document.name,
      fileType: document.type,
      bookingSetId
    };

    this.props.uploadFile({
      file: document,
      signSdk: signInventoryDocumentSdk,
      signData,
      startUploadingAction,
      storeIdentifierAction,
      finishUploadingAction
    });
  };

  render() {
    const {
      arrivalRoomCheck,
      uploadingImage,
      uploadingInventory,
      locationRef,
      imageUploadError
    } = this.props.data;

    return (
      <Modal
        className="ArrivalRoomCheckDetailModal"
        show={true}
        type={Modal.MEDIUM}
        onClose={this.props.closeModal}>
        <Modal.Header heading="Arrival room check" />
        {arrivalRoomCheck && (
          <Modal.Body>
            <div className="ArrivalRoomCheckDetailModal__section">
              <ArrivalRoomCheckBasicInformation
                arrivalRoomCheck={arrivalRoomCheck}
              />
              <ArrivalRoomCheckDetails
                arrivalRoomCheck={arrivalRoomCheck}
                bookingSetId={this.props.data.bookingSetId}
                fetchArrivalRoomCheckExtraActions={
                  this.fetchArrivalRoomCheckExtraActions
                }
                edittingDescription={this.props.data.edittingDescription}
                locationRef={locationRef}
              />
            </div>
            <div className="ArrivalRoomCheckDetailModal__section">
              <RoomCheckDetailImagesSection
                imageUploadError={imageUploadError}
                images={arrivalRoomCheck.images}
                uploadingImage={uploadingImage}
                removeImage={this.removeImage}
                dropImage={this.dropImage}
              />
            </div>
            <div className="ArrivalRoomCheckDetailModal__section">
              <RoomCheckDetailDocumentSection
                document={arrivalRoomCheck.inventory}
                uploadingDocument={uploadingInventory}
                removeDocument={this.removeInventory}
                dropDocument={this.dropInventory}
                documentIcon={inventoryIcon}
                placeholderText="Upload inventory"
                fileLabel="Inventory"
              />
            </div>
          </Modal.Body>
        )}
      </Modal>
    );
  }
}

const mapStateToModalData = (_state, data) => ({
  uploadingImage: _.get(data, 'uploadingImage', false),
  uploadingInventory: _.get(data, 'uploadingInventory', false)
});

const mapDispatchToProps = {
  fetchArrivalRoomCheck,
  removeArrivalRoomCheckImage,
  uploadFile,
  removeArrivalRoomCheckInventory,
  editArrivalRoomCheckExistingDamages,
  editArrivalRoomCheckDescription
};

export default withModal(
  MODALS.ARRIVAL_ROOM_CHECK_DETAIL_MODAL,
  mapStateToModalData,
  mapDispatchToProps
)(ArrivalRoomCheckDetailModal);
